import { render, staticRenderFns } from "./PartyDetails.vue?vue&type=template&id=6c3bf8b2&"
import script from "./PartyDetails.vue?vue&type=script&lang=js&"
export * from "./PartyDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports